/*
 *   Copyright (c) 2024
 *   All rights reserved.
 */

import { InfoWindow, Marker } from "@react-google-maps/api";

import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Table from "components/Table/Table.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import React, { useEffect, useMemo, useState } from "react";
import GridContainer from "components/Grid/GridContainer";
import { connect } from "react-redux";
import moment from "moment";
import FlexibleTable from "components/Table/FlexibleTable";
import { trajetSetTrajetSelectedAction } from "action/trajetAction";
import { tabColor } from "constance/constance";

const TabTrajetArret = (props) => {
  const [positionArretHook, setPositionArretHook] = useState([]);

  useEffect(() => {
    let positionArret;

    const positionLoop = props.loadTrajetFromSaga?.listTrajet.map(
      (cars, index) => {
        // cnt++;
        // console.log("cars =  ", cnt, " = ", cars);
        const dateDebut = moment(cars.heureDebut).format("DD-MM-YYYY HH:mm:ss");
        const dateFin = moment(cars.heureFin).format("DD-MM-YYYY HH:mm:ss");

        const addressDeb = cars.adresseDepart;
        const addressFin = cars.adresseArrivee;

        const distance = cars.distanceParcourue;
        const temps = cars.dureeTrajet;

        const roundDiv = (
          <div
            style={{
              width: "20px", // Taille du rond
              height: "20px", // Taille du rond
              borderRadius: "50%", // Rond parfait
              backgroundColor: tabColor[index], // Couleur dynamique
              display: "inline-block",
            }}
          ></div>
        );

        return {
          id: index,
          data: [
            index + 1,
            roundDiv,
            props.loadVehiculSelectedRedux.numeroImmatriculation,
            dateDebut,
            addressDeb,
            dateFin,
            addressFin,
            distance,
            temps + " mn",
          ],
        };
      }
    );
    setPositionArretHook(positionLoop);
  }, [props.loadTrajetFromSaga?.listTrajet]);

  return (
    <>
      <GridContainer direction="column" spacing={2}>
        <GridItem xs={12}>
          <Card>
            <CardBody>
              <FlexibleTable
                maxHeight={300}
                hover={true}
                handleClick={(id, data) => {
                  console.log("id = ", id);
                  props.updateSelectTrajetDispatch(id);
                }}
                indexCol={0}
                tableHeaderColor="primary"
                tableHead={[
                  "#",
                  "",
                  "vehicule",
                  "Date Depart",
                  "Adresse Depart ",
                  "Date arrive",
                  "Adresse arrive ",
                  "distance",
                  "duree",
                ]}
                tableData={positionArretHook}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </>
  );
};

const mapStateToProps = (state) => {
  console.log("trajet state ", state.trajet);

  return {
    loadTrajetFromSaga: state.trajet,
    loadVehiculSelectedRedux: state.vehicules.vehiculeSelected,
  };
};

const mapsDispatchToProps = (dispatch) => {
  return {
    updateSelectTrajetDispatch: (id) => {
      dispatch(trajetSetTrajetSelectedAction(id));
    },
  };
};

const styles = {
  circle: {
    width: "20px", // Taille du rond (largeur)
    height: "20px", // Taille du rond (hauteur)
    borderRadius: "50%", // Rayon pour rendre l'élément circulaire
    backgroundColor: "#ff0000", // Couleur du rond
    display: "inline-block", // Pour que le rond apparaisse en ligne
  },
};

export default connect(mapStateToProps, mapsDispatchToProps)(TabTrajetArret);
